module.exports = __webpack_public_path__ + "static/media/3.597ca540.jpg";